import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getPermission } from '../api/people'
import { setAccountPermissions } from '../redux/account/action'

export default function usePermissions() {
  const { user, permissions } = useSelector((state) => state.account)
  const dispatch = useDispatch()

  const getAccountPermissions = useCallback(async () => {
    if (user && !user.profile.password_reset_required && !permissions) {
      const resp = await getPermission()
      if (resp) {
        dispatch(setAccountPermissions(resp))
      }
    }
  }, [user, permissions])

  useEffect(() => {
    getAccountPermissions()
  }, [getAccountPermissions])

  const loaded = useMemo(
    () =>
      Boolean(
        (user ? user.profile.password_reset_required : true) || permissions
      ),
    [user, permissions]
  )

  return { loaded }
}
